declare const __webpack_public_path__: string;

export { createImportScriptsWorker } from './createImportScriptsWorker';
import { createImportScriptsWorker } from './createImportScriptsWorker';

export function createWssWorker(): Worker {
  if (typeof window !== 'undefined') {
    const workerUrl = new URL('WssWorker.js', __webpack_public_path__);
    if (workerUrl.origin !== window.location.origin) {
      return createImportScriptsWorker(workerUrl);
    }
  }

  try {
    return new Worker(new URL('./index.ts', import.meta.url), { name: 'WssWorker' });
  } catch (error) {
    const workerUrl = new URL('WssWorker.js', __webpack_public_path__);
    return createImportScriptsWorker(workerUrl);
  }
}
